import React, {useContext} from 'react';
import {Redirect, Route, useHistory, useParams, withRouter} from 'react-router-dom'
import {Button} from "antd";
import PropTypes from 'prop-types';

import BaseLayout from "../layout/baseLayout/baseLayout";
import MenuLayout from "../layout/menuLayout/menuLayout";
import {logout} from '@apis/result';
import {getTokenHeader, replaceUrlByParams, setTokenHeader} from "../utils/api";
import {PAGE} from '@utils/constants';
import {AppContext} from "../App";

UserRouter.propTypes = {
    component: PropTypes.func
};

function UserRouter({component: Component, ...rest}) {
    const {pid} = useParams();
    let history = useHistory();
    const {appSetting} = useContext(AppContext)
    const { adminToken, userToken } = getTokenHeader()

    function isLogin () {
        return userToken
    }

    const onLogout = async () => {
        try {
            const res = await logout();
            if (res && res.error) {
                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                setTokenHeader(adminToken, '');
                history.push(`${replaceUrlByParams(PAGE.LANDING, {':pid':pid})}`);
            }
        } catch (e) {
            // console.log(e)
        }
    }

    const actionBar = () => {
        return (
            <div className='action-bar'>
                {
                    isLogin && (
                        <Button className='logout-btn' type='primary' onClick={onLogout}>離開</Button>
                    )
                }
            </div>
        )
    }

    const menu = {
        activate: `${replaceUrlByParams(PAGE.USER_APPLICATION_DETAIL, {':pid':pid})}`,
        menuItems: [
            {
                key: `${replaceUrlByParams(PAGE.USER_APPLICATION_DETAIL, {':pid':pid})}`,
                title: '申請狀況'
            },
            {
                key: `${replaceUrlByParams(PAGE.USER_PAYMENT, {':pid':pid})}`,
                title: '付款狀況'
            }
        ]
    }

    return (
        <BaseLayout
            className='user-portal'
            logoSection={
                <a onClick={() => history.push(`${replaceUrlByParams(PAGE.LANDING, {':pid': pid})}`)} className='logo'>
                    <img src={ appSetting.logo } alt='logo' />
                </a>
            }
            actionBar={actionBar()}
        >
            <MenuLayout
                menu={menu}
            >
                <Route {...rest} render={props => (
                    isLogin() ?
                        <Component {...props} />
                        : <Redirect to={`${replaceUrlByParams(PAGE.USER_LOGIN, {':pid': pid})}`} />
                )} />
            </MenuLayout>
        </BaseLayout>
    );
}

export default withRouter(UserRouter);
